import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import "./styles/pwa-tokens.css";
import "./styles/portal-dark-theme.css";
import "./styles/desktop-portal.css";
import "./styles/desktop-portal-dark.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import { installPwaRecoveryHandlers } from "./utils/pwaRecovery";

installPwaRecoveryHandlers();

function hideBootSplash() {
  const el = document.getElementById("boot-splash");
  if (!el || el.dataset.hiding === "1") return;
  el.dataset.hiding = "1";
  el.classList.add("boot-splash-hide");
  window.setTimeout(() => el.remove(), 400);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

hideBootSplash();
